var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { attrs: { id: "section-physics" } },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "7" } },
                [
                  _c("ParallaxWrapper", { attrs: { factor: 0.2 } }, [
                    _c("img", {
                      attrs: {
                        src: require("@assets/images/dji-inspire-1.png"),
                        alt: "DJI Inspire",
                      },
                    }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { lg: "5" } },
                [
                  _c(_setup.FeatureDetailsBlock, {
                    attrs: {
                      title: "Real Flight Physics",
                      details:
                        "Each sUAS platform has a unique physics profile making for the most accurate flight physics of any commercially available drone simulator.",
                      justification: "right",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ParallaxWrapper", { attrs: { factor: -0.05 } }, [
        _c(
          "div",
          { staticClass: "shape-container" },
          [
            _c("div", { staticClass: "shape-a" }),
            _vm._v(" "),
            _c("ParallaxWrapper", { attrs: { factor: -0.05 } }, [
              _c("div", { staticClass: "shape-b" }),
            ]),
            _vm._v(" "),
            _c("ParallaxWrapper", { attrs: { factor: -0.08 } }, [
              _c("div", { staticClass: "shape-c" }),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }